export default __webpack_public_path__ + "static/media/wizard.a42ca369.less";